
export function updateDocumentTitle(breadcrumbItems) {
    const label = breadcrumbItems?.[breadcrumbItems.length - 1].label;
    if(label) {
        document.title = document.title.replace(/(.*)—/, `${label} —`);
    }
}
